module.exports = __webpack_public_path__ + "img/41.ca699e3a.png";